var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C10.8661 0 14 3.13394 14 7C14 10.8661 10.8661 14 7 14C3.13394 14 0 10.8661 0 7C0 3.13394 3.13394 0 7 0ZM7 1.23529C3.81624 1.23529 1.23529 3.81624 1.23529 7C1.23529 10.1838 3.81624 12.7647 7 12.7647C10.1838 12.7647 12.7647 10.1838 12.7647 7C12.7647 3.81624 10.1838 1.23529 7 1.23529ZM7.61765 5.76471V10.7059H6.38235V5.76471H7.61765ZM7.61765 3.70588V4.94118H6.38235V3.70588H7.61765Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.7d292cdc7593613d448207d87f75c802.svg";
export { ForwardRef as ReactComponent };